import DOMRefs from './dom-refs.js';

/**
 * Stub playback for Cypress when CDN/domain rules block real streams on localhost.
 * Intercepts play-trigger clicks and toggles embed UI state without the player SDK.
 *
 * @param {Object} handlers
 * @param {() => void} handlers.handlePlaybackStart
 * @param {() => void} handlers.handlePlaybackStop
 * @param {(state: 'PLAYING' | 'NOT_PLAYING') => void} handlers.setCurrentState
 */
export function registerCypressPlaybackStub({
  handlePlaybackStart,
  handlePlaybackStop,
  setCurrentState,
}) {
  let stubIsPlaying =
    DOMRefs.embedWrapper?.classList.contains('media-is-playing');

  document.addEventListener(
    'click',
    event => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const trigger = event.target.closest('tidal-play-trigger');

      if (!trigger) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (stubIsPlaying) {
        stubIsPlaying = false;
        setCurrentState('NOT_PLAYING');
        handlePlaybackStop();
      } else {
        stubIsPlaying = true;
        setCurrentState('PLAYING');
        handlePlaybackStart();
      }
    },
    true,
  );
}
